import React, { useEffect } from "react";
import useEmblaCarousel from "embla-carousel-react";
import "../../assets/css/TestimonialSlider.css";

/* =========================
   DATA
========================= */
const testimonials = [
    {
        text: "Best app to rent or lend anything, anywhere. Perfect time-saving application.",
        review: 5,
        name: "Vandan Boghra",
        initial: "V",
        color: "#d59f21ff",
    },
    {
        text: "This app is amazing and cool. You can rent anything safely and fast.",
        review: 5,
        name: "Vegad Kishan",
        initial: "V",
        color: "#7a5938ff",
    },
    {
        text: "Very good app, helps modern lifestyle and saves precious time 👌👌",
        review: 5,
        name: "Tirth Mungala",
        initial: "T",
        color: "#b7211fff",
    },
    {
        text: "Amazing app for special occasions, saved me money. Very smooth experience 👏🏻",
        review: 4,
        name: "Feni Gujarati",
        initial: "F",
        color: "#de1e21ff",
    },
    {
        text: "Excellent Rentel app! Easy to use, fast response, genuine listings.",
        review: 4,
        name: "Sanjog Paghdal",
        initial: "S",
        color: "#7c2b1dff",
    },
];

/* =========================
   STAR RENDER FUNCTION
========================= */
const renderStars = (rating) => {
    const fullStars = Math.floor(rating);      // full stars
    const hasHalfStar = rating % 1 !== 0;      // half star
    const emptyStars = 5 - Math.ceil(rating); // remaining

    return (
        <span style={{ color: "#f5b50a", fontSize: "16px" }}>
            {"★".repeat(fullStars)}
            {hasHalfStar && "⯪"} {/* half-star look */}
            {"☆".repeat(emptyStars)}
        </span>
    );
};

/* =========================
   COMPONENT
========================= */
const TestimonialSlider = () => {
    const [emblaRef, emblaApi] = useEmblaCarousel({
        loop: true,
        align: "start",
    });

    /* 🔥 AUTOPLAY */
    useEffect(() => {
        if (!emblaApi) return;

        const timer = setInterval(() => {
            emblaApi.scrollNext();
        }, 2800);

        return () => clearInterval(timer);
    }, [emblaApi]);

    return (
        <div className="container">
            <div className="ts-wrapper">
                <h1 className="ts-heading">Testimonials</h1>
                <h3 className="ts-subheading">
                    List your freelancing services or spare items on Rentel
                </h3>

                <div className="ts-slider embla" ref={emblaRef}>
                    <div className="embla__container">
                        {testimonials.map((item, index) => (
                            <div key={index} className="ts-slide embla__slide">
                                <div className="ts-card">
                                    <span className="ts-quote">“</span>

                                    <p className="ts-text">{item.text}</p>

                                    <div className="ts-user">
                                        <div
                                            className="ts-avatar"
                                            style={{ backgroundColor: item.color }}
                                        >
                                            {item.initial}
                                        </div>

                                        <div>
                                            <p className="ts-name">{item.name}</p>

                                            {/* ⭐ STAR RATING */}
                                            <p className="ts-location">
                                                {renderStars(item.review)}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TestimonialSlider;
